module.exports = {
  'selectLanguage': 'Selectați limba'
};
